import * as s from "./UsageSignupStyled";
import UsageSignupContent from "./UsageSignupContent";
import { UsageSignupFlow } from "./useUsageSignupFlow";
import Spinner from "components/atoms/loader/Spinner";

interface Props {
  flow: UsageSignupFlow;
  onAddPayment: () => void;
}

export default function UsageSignupPresenter(props: Props): JSX.Element {
  if (props.flow.state.isLoading) {
    return <Spinner />;
  }

  return (
    <s.Page>
      <s.Card>
        <s.Inner>
          <UsageSignupContent
            flow={props.flow}
            onAddPayment={props.onAddPayment}
          />
        </s.Inner>
      </s.Card>
    </s.Page>
  );
}
